interface ErrorMessageProps {
  children: React.ReactNode;
}

const ErrorMessage = ({ children }: ErrorMessageProps) => {
  return <p className="text-sm text-destructive">{children}</p>;
};

export default ErrorMessage;